import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\beats\\beats-machine.tsx");
